export const defaultSearchParam = 'search';

export const pageSizeOptions = [10, 20, 30, 40, 50];
